import React, { useEffect, useState } from 'react'
import { LuArrowUpDown } from 'react-icons/lu';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { getCallLogTransactionList } from '../../../service/api/paymentGateway/getCallLogTransactionList';
import { IoIosArrowDown, IoIosArrowUp } from 'react-icons/io';
import { FaSearch } from 'react-icons/fa';
import SkeletonDivElement from '../../../component/skeletonTableRow/skeletonDivElement';
import emptyListImg from '../../../media/images/servicesAssets/emptyListImg.png'
import { getCreditHistoryApi } from '../../../service/api/user/getCreditHisoty';

const CreditHistory = () => {
    const { paymentMethodID, customerID, impersonateFlag, permissionArr, role, connectedAccountId, companyId, totalCreditsInCents } = useSelector((state) => state.user);
    const { totalEarned } = useSelector((state) => state.finance);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const permissionArray = permissionArr[0] || []

    const [paymentHistoryArrCust, setPaymentHistoryArrCust] = useState([]);



    const [listLoading, setListLoading] = useState(false)

    const [filtreBox, setFiltreBox] = useState(false);
    const [filtreValue, SetFiltreValue] = useState(1);

    const convertUnixTime = (unixTime) => {
        // Create a new Date object from the Unix timestamp
        // Note: Unix timestamp should be in milliseconds for JavaScript Date object,
        // so we multiply by 1000 (because Unix timestamp is usually in seconds).
        const date = new Date(unixTime * 1000);

        // Define an array of month names to convert month number to month name
        const months = ["January", "February", "March", "April", "May", "June",
            "July", "August", "September", "October", "November", "December"];

        // Extract the day, month and year from the date
        const day = date.getDate();
        const month = months[date.getMonth()];
        const year = date.getFullYear();

        // Return the formatted date string
        return `${month} ${day}, ${year}`;
    }

    let USDollar = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
    });

    const viewServiceDetails = (element) => {
        localStorage.setItem("ticket_id", element?.service_request_id_lng);
        navigate("/serviceRequestDetails");
    }

    // New functions for the sorting and pagination 
    const [page, setPage] = React.useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [totalPage, setTotalPage] = useState(1);
    const [sortByValue, setSortByValue] = useState("DESC");
    const [searchValue, setSearchValue] = useState("");
    const [bulkDeleteArr, setBulkDeleteArr] = useState([]);
    const [skeltonVal, setSkeltonVal] = useState(false);
    const [columnName, setColumnName] = useState("");
    const [totalNoRecord, setTotalNoRecord] = useState(100);
    const [flag, setFlag] = useState(false);

    // const [elements, setElements] = useState([]);

    const handlePaymentTransactionLists = (res) => {
        const newElements = [...paymentHistoryArrCust, ...res.data.data];
        const uniqueElements = Array.from(
            new Set(newElements.map(JSON.stringify))
        ).map(JSON.parse);
        setPaymentHistoryArrCust(uniqueElements);
        setTotalNoRecord(res.data.total_count);
        if (res.total_count % pageSize === 0) {
            setTotalPage(parseInt(res.total_count / pageSize));
        } else {
            setTotalPage(parseInt(res.total_count / pageSize + 1));
        }
    }

    const getPaymentTractionListFn = () => {

        let data = new FormData();
        data.append("user_id_ids", localStorage.getItem("user_id"))
        data.append("pagination_flag", 1)
        data.append("page_index", page)
        data.append("page_size", pageSize)
        data.append("sorting_order", sortByValue)
        data.append("sorting_column_name", columnName)
        data.append("search_area", searchValue)

        setListLoading(true);
        dispatch(
            getCreditHistoryApi(
                data,
                (res) => {
                    // console.log(res.data.data, "getPaymentTractionListFn")
                    handlePaymentTransactionLists(res);
                    setListLoading(false);
                },
                (res) => {
                    // console.log(res.data.data);
                    setListLoading(false);
                }
            )
        );
    };

    const getPaymentTractionListSearch = () => {
        let data = new FormData();
        data.append("user_id_ids", localStorage.getItem("user_id"))
        data.append("pagination_flag", 1)
        data.append("page_index", page)
        data.append("page_size", pageSize)
        data.append("sorting_order", sortByValue)
        data.append("sorting_column_name", columnName)
        data.append("search_area", searchValue)

        setListLoading(true);
        dispatch(
            getCreditHistoryApi(
                data,
                (res) => {
                    // console.log(res.data.data, "getPaymentTractionListFn search")
                    handlePaymentTransactionLists(res);
                    setListLoading(false);
                },
                (res) => {
                    // console.log(res.data.data);
                    setListLoading(false);
                }
            )
        );
    };

    useEffect(() => {
        if (searchValue.trim().length > 2) {
            setFlag(true);
            const timeOutId = setTimeout(getPaymentTractionListSearch, 1000);
            return () => clearTimeout(timeOutId);
        } else if (searchValue.trim().length === 0) {
            if (flag) {
                getPaymentTractionListSearch();
            }
        }
    }, [searchValue]);

    function handleOpenFiltreBox() {
        setFiltreBox(!filtreBox);
    }

    function handleSetFiltreValue(v) {
        SetFiltreValue(v);
        const ele = [];
        setPage(1);
        setPaymentHistoryArrCust(ele);
        // setTransactionList(ele);
        if (v === 1) {
            setSortByValue("DESC");
        } else if (v === 2) {
            setSortByValue("ASC");
        }
    }

    const handleSearch = (e) => {
        // setPage(1)
        // handleToggle(null);
        if (searchValue.trim().length >= 2) {
            onChangePage(1);
            setColumnName("");
        }
        setSearchValue(e.target.value);
    };

    const onChangePage = (e, p) => {
        // setPage(p)
        // handleToggle(null);
        setPage(e);
    };

    useEffect(() => {
        setPage(1);
        setPaymentHistoryArrCust([]);
    }, [searchValue]);

    useEffect(() => {
        getPaymentTractionListFn();
    }, [page, pageSize, sortByValue, columnName, filtreValue])

    return (
        <>
            <div className='row mx-0 py-2'>
                <div className='col-12 px-0'>

                    <div className='fs-6 mt-2'>
                        <span>{`Available credit balance: `}</span>
                        <span className='text-black font-w600'>{`${USDollar.format(totalCreditsInCents / 100)}`}</span>
                    </div>
                    <div
                        className="row border-bottom px-2 my-1"
                        style={{
                            // backgroundColor: "rgba(251, 252, 255, 1)",
                            // borderRadius: '16px',
                        }}
                    >
                        <div
                            className="row mx-0 my-3 align-items-center "
                            style={{ minHeight: "40px" }}
                        >

                            <div className="col-12">
                                <div className="row">
                                    <span className="fs-6 p-2 d-flex align-items-center justify-content-end">

                                        <span className="fs-5 p-2 d-flex align-items-center">
                                            <LuArrowUpDown
                                                className="pointer"
                                                style={{ marginRight: "4px", color: "black" }}
                                                onClick={handleOpenFiltreBox}
                                            />
                                            <span
                                                className="fs-6  pointer"
                                                style={{ position: "relative" }}
                                                onClick={handleOpenFiltreBox}>
                                                {filtreValue == 1 && "Date: Newest first"}
                                                {filtreValue == 2 && "Date: Oldest first"}
                                                {/* {filtreValue == 3 && " Price: Highest first"}
                                          {filtreValue == 4 && "Price: Lowest first"}{" "} */}
                                                &nbsp;
                                                {filtreBox ? <IoIosArrowUp /> : <IoIosArrowDown />}
                                                <span
                                                    className={`${filtreBox ? "" : "d-none"} p-3`}
                                                    style={{
                                                        position: "absolute",
                                                        top: "26px",
                                                        width: "170px",
                                                        zIndex: 1,
                                                        border: "1px solid lightgray",
                                                        background: "white",
                                                        right: "0",
                                                        boxShadow: "0px 4px 12px 0px rgba(0, 0, 0, 0.12)",
                                                    }}>
                                                    <div className="row">
                                                        <div
                                                            className={`${filtreValue == 1 ? "dt" : ""
                                                                } d-flex justify-content-start m-1 pointer `}
                                                            onClick={() => {
                                                                handleSetFiltreValue(1);
                                                            }}>
                                                            <div className="d-flex align-items-center" style={{ width: '20px' }}>
                                                                {filtreValue == 1 && <i className="bi bi-check-lg"></i>}
                                                            </div>
                                                            Date: Newest first
                                                        </div>
                                                        <div
                                                            className={`${filtreValue == 2 ? "dt" : ""
                                                                } d-flex justify-content-start m-1 pointer`}
                                                            onClick={() => {
                                                                handleSetFiltreValue(2);
                                                            }}>
                                                            <div className="d-flex align-items-center" style={{ width: '20px' }}>
                                                                {filtreValue == 2 && <i className="bi bi-check-lg"></i>}
                                                            </div>
                                                            Date: Oldest first
                                                        </div>

                                                    </div>
                                                </span>
                                            </span>
                                        </span>

                                        <span
                                            className="fs-6 p-2 d-flex align-items-center"
                                            style={{
                                                border: "1px solid lightgray",
                                                borderRadius: "6px",
                                            }}>
                                            <FaSearch style={{ marginRight: "4px", color: "black" }} />
                                            <input
                                                placeholder="Search"
                                                style={{ border: "0px", width: "100%" }}
                                                onChange={handleSearch}
                                                value={searchValue}
                                            />
                                        </span>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <>
                        <>
                            <div className='overflow-auto py-2 ' style={{}}>
                                {paymentHistoryArrCust?.length > 0 ?
                                    <>
                                        {
                                            paymentHistoryArrCust.map((element, index) => {
                                                return (
                                                    <>
                                                        <div key={index} className='row mx-0 border-bottom py-3'>
                                                            <div className='col-12 px-0'>
                                                                <div className='row mx-2 mb-1'>
                                                                    <div className='col-12 px-0 d-flex justify-content-between align-items-center'>
                                                                        <div className='font-w500 text-black'>
                                                                            {/* <span>{`A ${(element?.call_duration_in_second / 60).toFixed(2)} minute video call costs ${USDollar.format(element?.payment_intent_meta_data?.amount_received / 100)}.`}</span> */}
                                                                            <span>{`${element?.description_chr ? element?.description_chr : "-"}`}</span>
                                                                        </div>

                                                                        <div
                                                                            className={`font-w600 ${element?.type_chr == "DEBIT" ? 'text-danger' : 'text-success'}`}

                                                                        >
                                                                            {element?.type_chr == "DEBIT" && <span>{`-`}</span>}
                                                                            <span>{`${USDollar.format(element?.number_of_credits_float ? (element?.number_of_credits_float / 100) : 0)}`}</span>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                <div className='row mx-2'>
                                                                    <div className='col-12 px-0 mb-1 d-flex justify-content-between align-items-center'>
                                                                        <div>
                                                                            {/* <span>{`${convertUnixTime(element?.created_date_dtm)}`}</span> */}

                                                                            <span className="">{`${element?.created_date_dtm ?
                                                                                new Intl.DateTimeFormat("en-US", {
                                                                                    year: "numeric",
                                                                                    month: "short",
                                                                                    day: "numeric",
                                                                                    hour: 'numeric',
                                                                                    minute: 'numeric',
                                                                                    hour12: true
                                                                                }).format(
                                                                                    element?.created_date_dtm * 1000
                                                                                ) : '-'}`}</span>
                                                                        </div>


                                                                    </div>
                                                                </div>

                                                                {element?.service_request_id_lng &&
                                                                    <div className='row mx-2 '>
                                                                        <div className='col-12 px-0 d-flex justify-content-start'>
                                                                            <span
                                                                                className='font-w600  text-hovered cursor-pointer'
                                                                                onClick={() => { viewServiceDetails(element) }}
                                                                                style={{
                                                                                    color: 'rgba(131, 154, 192, 1)'
                                                                                }}
                                                                            >
                                                                                {`See service details`}
                                                                                <i className='bi bi-chevron-right ps-2'></i>
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                }
                                                            </div>
                                                        </div>
                                                    </>
                                                )
                                            })
                                        }

                                        {listLoading
                                            ? paymentHistoryArrCust?.length > 0 &&
                                            totalNoRecord > paymentHistoryArrCust?.length && (
                                                <div className="text-center pointer my-2">Loading ...</div>
                                            )
                                            : paymentHistoryArrCust?.length > 0 &&
                                            totalNoRecord > paymentHistoryArrCust?.length && (
                                                <div
                                                    className="text-center pointer my-3"
                                                    onClick={() => {
                                                        setPage(page + 1);
                                                    }}>
                                                    click to view more
                                                </div>
                                            )}

                                    </>
                                    :
                                    <>
                                        {!listLoading && <div className='row mx-2 fs-6 py-2 mt-3'>
                                            <div className='col-12 px-0 d-flex justify-content-center align-items-center flex-column'>
                                                <img src={emptyListImg} style={{ width: "70px" }} alt="" />
                                                <span className='mt-3 fs-7'>{"No credit history"}</span>
                                            </div>
                                        </div>}
                                    </>
                                }
                                {listLoading &&
                                    <SkeletonDivElement
                                        height={"80px"}
                                        rows={10}
                                        marginBottom={'5px'}
                                        borderRadius={'0px'}
                                    />
                                }
                            </div>
                        </>


                    </>
                </div>
            </div>
        </>
    )
}

export default CreditHistory